export default function getFlowParameter(state) {
  let flowParameter = "signin";
  if (state.loginForm && state.loginForm.flowParameter) {
    flowParameter = state.loginForm.flowParameter.trim();
  }
  return flowParameter;
}